export default __webpack_public_path__ + "static/media/stratergies.7140de5e.jpg";